export default __webpack_public_path__ + "static/media/piper-grass.d1351e60.jpg";